import React, { useEffect, useState } from "react";
import { Box, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import NewsCard from "./newsCard/NewsCard";
import axios from "axios";


const MainBox = styled(Box)(({theme}) => ({
  width: '97%',
  height: '90%',
  backgroundColor: "azure",
  borderRadius: "20px",
  display: "flex",
  flexDirection: 'column',
  alignItems: "center",
  [theme.breakpoints.down('sm')]: {
    width: '95%',
    borderRadius: "10px",
  }
}))

const NewsBox = styled(Box)(({theme}) => ({
  width: '100%',
  height: '90%',
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }
}))

const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: '2.1rem',
  gridTemplateColumns: 'auto auto',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
  }
}))


function News_PressReleaseSection() {

  const [fetchedNews, setFetchedNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Mobile screen check
   

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(
          "https://newsdata.io/api/1/news?apikey=pub_73267adcd40c1e27c7aa08b21f62ff65aaa92&language=en,hi,mr&category=business,food,health,lifestyle,politics"
        );
        setFetchedNews(response.data.results);
      } catch (err) {
        setError("Failed to fetch news. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  // console.log(fetchedNews);
  

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;


  return (
    <Box
      sx={{
        height: "100vh",
        bgcolor: "rgb(176, 181, 189)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <MainBox>
        <Box
          sx={{
            width: '100%',
            height: "10%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <StyledTypography
            fontWeight={600}
            sx={{ fontFamily: "sans-serif" }}
          >
            News & Press Releases
          </StyledTypography>
        </Box>
        <NewsBox>
            {fetchedNews.slice(0, isMobile ? 4 : 6).map((items, index) => (
                <NewsCard key={index} {...items} />
            ))}
        </NewsBox>
      </MainBox>
    </Box>
  );
}

export default News_PressReleaseSection;
